/* eslint-disable import/prefer-default-export */

//Mobile
export const MOBILE_WIDTH_PX = '768';

//Auth & Login
export const SET_RUNTIME_VARIABLE = 'SET_RUNTIME_VARIABLE';
export const SET_LOCALE_START = 'SET_LOCALE_START';
export const SET_LOCALE_SUCCESS = 'SET_LOCALE_SUCCESS';
export const SET_LOCALE_ERROR = 'SET_LOCALE_ERROR';
export const SET_APP_MODE = 'SET_APP_MODE';
export const FETCH_USERS = 'FETCH_USERS';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_UNAUTHORIZED = 'AUTH_UNAUTHORIZED';
export const RESPONSE_END = 'RESPONSE_END';
export const RESPONSE_WAIT = 'RESPONSE_WAIT';
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
export const LOCALSTORAGE_AUTH_KEY = 'prestadores_smg_auth';
export const LOCALSTORAGE_TOKEN_EXPIRATION = 'prestadores_token_exp';
export const HOST_SERVER = 'http://192.168.104.126/';
export const LOGIN_STATUS_PENDING = 'LOGIN_STATUS_PENDING';
export const LOGIN_STATUS_LOGGED_IN = 'LOGIN_STATUS_LOGGED_IN';
export const LOGIN_STATUS_UNAUTHORIZED = 'LOGIN_STATUS_UNAUTHORIZED';
export const LOGIN_STATUS_ERROR_401 = 'LOGIN_STATUS_ERROR_401';
export const LOGIN_STATUS_NOT_LOGGED_IN = 'LOGIN_STATUS_NOT_LOGGED_IN';
export const RECAPTCHA_TOKEN = 'RECAPTCHA_TOKEN';
export const ERROR_401 = '401';

//Consulta Liquidacion
export const CONSULTA_LIQUIDACION_SUCCESS = 'CONSULTA_LIQUIDACION_SUCCESS';
export const CONSULTA_LIQUIDACION_ERROR = 'CONSULTA_LIQUIDACION_ERROR';
export const CONSULTA_DEBITOS_SUCCESS = 'CONSULTA_DEBITOS_SUCCESS';
export const CONSULTA_DEBITOS_ERROR = 'CONSULTA_DEBITOS_ERROR';
export const CONSULTA_DETALLES_SUCCESS = 'CONSULTA_DETALLES_SUCCESS';
export const CONSULTA_DETALLES_ERROR = 'CONSULTA_DETALLES_ERROR';
export const CONSULTA_RESPONSE_WAIT = 'CONSULTA_RESPONSE_WAIT';
export const CONSULTA_RESPONSE_END = 'CONSULTA_RESPONSE_END';

//Receta & Firma digital
export const OBTENER_RECETA_DIGITAL_SUCCESS = 'OBTENER_RECETA_DIGITAL_SUCCESS';
export const OBTENER_RECETA_DIGITAL_ERROR = 'OBTENER_RECETA_DIGITAL_ERROR';
export const FIRMA_RECETA_DIGITAL_SUCCESS = 'FIRMA_RECETA_DIGITAL_SUCCESS';
export const FIRMA_RECETA_DIGITAL_ERROR = 'FIRMA_RECETA_DIGITAL_ERROR';

//Reportes y descarga PDF
export const OBTENER_REPORTES_SUCCESS = 'OBTENER_REPORTES_SUCCESS';
export const OBTENER_REPORTES_ERROR = 'OBTENER_REPORTES_ERROR';
export const DESCARGAR_PDF_SUCCESS = 'DESCARGAR_PDF_SUCCESS';
export const DESCARGAR_PDF_ERROR = 'DESCARGAR_PDF_ERROR';
/* TableFilter.js Textos */

//Obtener: Prestaciones Exceptuadas, Direcciones & Sanatorios
export const OBTENER_PRESTACIONES_EXCEPTUADAS_ERROR = 'OBTENER_PRESTACIONES_EXCEPTUADAS_ERROR';
export const OBTENER_PRESTACIONES_EXCEPTUADAS_SUCCESS = 'OBTENER_PRESTACIONES_EXCEPTUADAS_SUCCESS';
export const OBTENER_DIRECCIONES_SUCCESS = 'OBTENER_DIRECCIONES_SUCCESS';
export const OBTENER_DIRECCIONES_ERROR = 'OBTENER_DIRECCIONES_ERROR';
export const OBTENER_DIRECCIONES_ELEGIBILIDAD_SUCCESS = 'OBTENER_DIRECCIONES_ELEGIBILIDAD_SUCCESS';
export const OBTENER_DIRECCIONES_ELEGIBILIDAD_ERROR = 'OBTENER_DIRECCIONES_ELEGIBILIDAD_ERROR';
export const OBTENER_SANATORIO_SUCCESS = 'OBTENER_SANATORIO_SUCCESS';
export const OBTENER_SANATORIO_ERROR = 'OBTENER_SANATORIO_ERROR';

//Circulo
export const GET_CIRCLE_DATA_SUCCESS = 'GET_CIRCLE_DATA_SUCCESS';
export const GET_CIRCLE_DATA_ERROR = 'GET_CIRCLE_DATA_ERROR';

//Validación afiliados
export const VALIDAR_AFILIADO_SUCCESS = 'VALIDAR_AFILIADO_SUCCESS';
export const VALIDAR_AFILIADO_ERROR = 'VALIDAR_AFILIADO_ERROR';
export const VALIDAR_AFILIADO_ELEGIBILIDAD_SUCCESS = 'VALIDAR_AFILIADO_ELEGIBILIDAD_SUCCESS';
export const VALIDAR_AFILIADO_ELEGIBILIDAD_ERROR = 'VALIDAR_AFILIADO_ELEGIBILIDAD_ERROR';
export const VALIDAR_AFILIADO_INMEDIATA_SUCCESS = 'VALIDAR_AFILIADO_INMEDIATA_SUCCESS';
export const VALIDAR_AFILIADO_INMEDIATA_ERROR = 'VALIDAR_AFILIADO_INMEDIATA_ERROR';

//Búsqueda de trámites por fecha
export const BUSCAR_TRAMITE_POR_FECHA_SUCCESS = 'BUSCAR_TRAMITE_POR_FECHA_SUCCESS';
export const BUSCAR_TRAMITE_POR_FECHA_ERROR = 'BUSCAR_TRAMITE_POR_FECHA_ERROR';

//Guardado de datos
export const GUARDAR_DATOS_SUCCESS = 'GUARDAR_DATOS_SUCCESS';
export const GUARDAR_DATOS_ERROR = 'GUARDAR_DATOS_ERROR';
export const GUARDAR_DATOS_CONECTIVIDAD_SUCCESS = 'GUARDAR_DATOS_CONECTIVIDAD_SUCCESS';
export const GUARDAR_DATOS_CONECTIVIDAD_ERROR = 'GUARDAR_DATOS_CONECTIVIDAD_ERROR';
export const GUARDAR_DATOS_ELEGIBILIDAD_SUCCESS = 'GUARDAR_DATOS_ELEGIBILIDAD_SUCCESS';
export const GUARDAR_DATOS_ELEGIBILIDAD_ERROR = 'GUARDAR_DATOS_ELEGIBILIDAD_ERROR';
export const GUARDAR_DATOS_INGRESAR_DIAGNOSTICO_SUCCESS =
  'GUARDAR_DATOS_INGRESAR_DIAGNOSTICO_SUCCESS';
export const GUARDAR_DATOS_CENSOS_SUCCESS = 'GUARDAR_DATOS_CENSOS_SUCCESS';
export const GUARDAR_DATOS_CENSOS_ERROR = 'GUARDAR_DATOS_CENSOS_ERROR';
export const GUARDAR_DATOS_INGRESAR_DIAGNOSTICO_ERROR = 'GUARDAR_DATOS_INGRESAR_DIAGNOSTICO_ERROR';
export const GUARDAR_DATOS_ANULAR_DIAGNOSTICO_SUCCESS = 'GUARDAR_DATOS_ANULAR_DIAGNOSTICO_SUCCESS';
export const GUARDAR_DATOS_ANULAR_DIAGNOSTICO_ERROR = 'GUARDAR_DATOS_ANULAR_DIAGNOSTICO_ERROR';
export const GUARDAR_DATOS_REIMPRESION_SUCCESS = 'GUARDAR_DATOS_REIMPRESION_SUCCESS';
export const GUARDAR_DATOS_REIMPRESION_ERROR = 'GUARDAR_DATOS_REIMPRESION_ERROR';
export const GUARDAR_DATOS_ANULAR_PRESTACION_SUCCESS = 'GUARDAR_DATOS_ANULAR_PRESTACION_SUCCESS';
export const GUARDAR_DATOS_ANULAR_PRESTACION_ERROR = 'GUARDAR_DATOS_ANULAR_PRESTACION_ERROR';
export const GUARDAR_DATOS_INMEDIATA_SUCCESS = 'GUARDAR_DATOS_INMEDIATA_SUCCESS';
export const GUARDAR_DATOS_INMEDIATA_ERROR = 'GUARDAR_DATOS_INMEDIATA_ERROR';
export const RESET_TRANSACTION = 'RESET_TRANSACTION';

//Obtener: Codigo diagnóstico && prestaciones
export const OBTENER_CODIGO_DIAGNOSTICO_SUCCESS = 'OBTENER_CODIGO_DIAGNOSTICO_SUCCESS';
export const OBTENER_CODIGO_DIAGNOSTICO_ERROR = 'OBTENER_CODIGO_DIAGNOSTICO_ERROR';
export const OBTENER_PRESTACIONES_SUCCESS = 'OBTENER_PRESTACIONES_SUCCESS';
export const OBTENER_PRESTACIONES_ERROR = 'OBTENER_PRESTACIONES_ERROR';

//Validar dirección & Cobertura
export const VALIDAR_DIRECCION_SUCCESS = 'VALIDAR_DIRECCION_SUCCESS';
export const VALIDAR_DIRECCION_ERROR = 'VALIDAR_DIRECCION_ERROR';
export const VALIDAR_COBERTURA_SUCCESS = 'VALIDAR_COBERTURA_SUCCESS';
export const VALIDAR_COBERTURA_ERROR = 'VALIDAR_COBERTURA_ERROR';
export const VALIDAR_DIRECCION_INMEDIATA_SUCCESS = 'VALIDAR_DIRECCION_INMEDIATA_SUCCESS';
export const VALIDAR_DIRECCION_INMEDIATA_ERROR = 'VALIDAR_DIRECCION_INMEDIATA_ERROR';

export const SELECT_LABEL_TEXT = 'Mes';
export const SETTLEMENT_FILTER_OFFICE_NUMBER = 'Oficina';

export const CONSULTA_ADJUNTAR_COMPROBANTES_START = 'CONSULTA_ADJUNTAR_COMPROBANTES_START';
export const CONSULTA_ADJUNTAR_COMPROBANTES_CANCEL = 'CONSULTA_ADJUNTAR_COMPROBANTES_CANCEL';
export const CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS = 'CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS';
export const CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_SHOW_MODAL =
  'CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_SHOW_MODAL';
export const CONSULTA_ADJUNTAR_COMPROBANTES_ERROR_SHOW_MODAL =
  'CONSULTA_ADJUNTAR_COMPROBANTES_ERROR_SHOW_MODAL';
export const CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_HIDE_MODAL =
  'CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_HIDE_MODAL';
export const CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_SPINNER_MODAL =
  'CONSULTA_ADJUNTAR_COMPROBANTES_SUCCESS_SPINNER_MODAL';
export const DISPLAY_MESSAGE = 'DISPLAY_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const PRESTADOR_ES_DIRECTO = 'PRESTADOR_ES_DIRECTO';
export const FETCH_CALIFICACIONES = 'FETCH_CALIFICACIONES';
export const FETCH_MOSTRAR_CALIFICACIONES = 'FETCH_MOSTRAR_CALIFICACIONES';
export const SET_CURRENT_CALIFICACIONES_STATUS = 'SET_CURRENT_CALIFICACIONES_STATUS';
export const RESET_TO_LAST_SAFE_CONFIGURATION = 'RESET_TO_LAST_SAFE_CONFIGURATION';

// Consulta pagos & facturas
export const OBTENER_EMPRESAS_SUCCESS = 'OBTENER_EMPRESAS_SUCCESS';
export const OBTENER_EMPRESAS_ERROR = 'OBTENER_EMPRESAS_ERROR';
export const OBTENER_MOTIVOS_SUCCESS = 'OBTENER_MOTIVOS_SUCCESS';
export const OBTENER_MOTIVOS_ERROR = 'OBTENER_MOTIVOS_ERROR';
export const OBTENER_SUBMOTIVOS_SUCCESS = 'OBTENER_SUBMOTIVOS_SUCCESS';
export const OBTENER_SUBMOTIVOS_ERROR = 'OBTENER_SUBMOTIVOS_ERROR';
export const OBTENER_ESTADOS_SUCCESS = 'OBTENER_ESTADOS_SUCCESS';
export const OBTENER_ESTADOS_ERROR = 'OBTENER_ESTADOS_ERROR';
export const CONSULTA_PAGOS_Y_FACTURAS_SUCCESS = 'CONSULTA_PAGOS_Y_FACTURAS_SUCCESS';
export const CONSULTA_PAGOS_Y_FACTURAS_ERROR = 'CONSULTA_PAGOS_Y_FACTURAS_ERROR';
export const NUEVA_CONSULTA_SUCCESS = 'NUEVA_CONSULTA_SUCCESS';
export const NUEVA_CONSULTA_ERROR = 'NUEVA_CONSULTA_ERROR';
export const OBTENER_TRAMITES_ANTERIORES_SUCCESS = 'OBTENER_TRAMITES_ANTERIORES_SUCCESS';
export const OBTENER_TRAMITES_ANTERIORES_ERROR = 'OBTENER_TRAMITES_ANTERIORES_ERROR';
export const AGREGAR_COMENTARIO_SUCCESS = 'AGREGAR_COMENTARIO_SUCCESS';
export const AGREGAR_COMENTARIO_ERROR = 'AGREGAR_COMENTARIO_ERROR';
export const OBTENER_ARCHIVOS_ADJUNTOS_SUCCESS = 'OBTENER_ARCHIVOS_ADJUNTOS_SUCCESS';
export const OBTENER_ARCHIVOS_ADJUNTOS_ERROR = 'OBTENER_ARCHIVOS_ADJUNTOS_ERROR';
export const TIPO_PRESTADOR = 'TIPO_PRESTADOR';
export const TIPO_PRODUCTOR = 'TIPO_PRODUCTOR';
export const FIRST_CONSULTORIOS = 'FIRST_CONSULTORIOS';
export const SEARCH_CONSULTORIOS = 'SEARCH_CONSULTORIOS';
export const FETCH_EN_LIQUIDACION = 'FETCH_EN_LIQUIDACION';
export const FETCH_FACTURAS = 'FETCH_FACTURAS';
export const RESET_FACTURAS = 'RESET_FACTURAS';
export const FETCH_PENDIENTE = 'FETCH_PENDIENTE';
export const FETCH_PRESENTADA = 'FETCH_PRESENTADA';
export const HIDE_FILTERS = 'HIDE_FILTERS';
export const LOADING_FACTURAS = 'LOADING_FACTURAS';
export const LOADING_FACTURAS_END = 'LOADING_FACTURAS_END';
export const SEARCH_FACTURAS = 'SEARCH_FACTURAS';
export const SHOW_FILTERS = 'SHOW_FILTERS';
export const DETALLE_OP_SUCCESS = 'DETALLE_OP_SUCCESS';
export const SEARCH_PAGOS = 'SEARCH_PAGOS';
export const RESET_PAGOS = 'RESET_PAGOS';
export const LOADING_PAGOS = 'LOADING_PAGOS';
export const LOADING_PAGOS_END = 'LOADING_PAGOS_END';
export const LOADING_DETAIL = 'LOADING_DETAIL';
export const LOADING_DETAIL_END = 'LOADING_DETAIL_END';
export const RESET_SUBMOTIVOS = 'RESET_SUBMOTIVOS';
export const RESET_TRAMITES_ANTERIORES = 'RESET_TRAMITES_ANTERIORES';
export const FETCH_CONSULTORIOS = 'FETCH_CONSULTORIOS';
export const SMG_WEB_PRESTADORES = 'SMG Web Prestadores';

export const RESET_CONNECTIVITY_STATE = 'RESET_CONNECTIVITY_STATE';

// CAP Web

// Tramite Seleccionado
export const SET_TRAMITE_SELECCIONADO_CAP = 'SET_TRAMITE_SELECCIONADO_CAP';

//Emails Asociados
export const EMAILS_ASOCIADOS = 'EMAILS_ASOCIADOS';

//Obtener Domicilios
export const OBTENER_DOMICILIOS_ADP_SUCCESS = 'OBTENER_DOMICILIOS_ADP_SUCCESS';
export const OBTENER_DOMICILIOS_ADP_ERROR = 'OBTENER_DOMICILIOS_ADP_ERROR';

//Seteo de tramites
export const SET_TRAMITE_ACCION_ADP = 'SET_TRAMITE_ACCION_ADP';
export const SET_TRAMITE_GUARDADO_OK = 'SET_TRAMITE_GUARDADO_OK';

//Ambitos, areas consulta, motivos, & detalle de trámites
export const CONTRATACIONES_AMBITO = 'CONTRATACIONES_AMBITO';
export const AREAS_CONSULTA = 'AREAS_CONSULTA';
export const CONTRATACIONES_MOTIVOS = 'CONTRATACIONES_MOTIVOS';
export const AUTORIZACIONES_MOTIVOS = 'AUTORIZACIONES_MOTIVOS';
export const LIQUIDACIONES_MOTIVOS = 'LIQUIDACIONES_MOTIVOS';
export const DETALLE_TRAMITES_CAP = 'DETALLE_TRAMITES_CAP';
export const RESET_CAP_WEB_STATE = 'RESET_CAP_WEB_STATE';

//Inbox && Table
export const FETCH_INBOX = 'FETCH_INBOX';
export const LOAD_INBOX = 'LOAD_INBOX';
export const LOAD_TABLE = 'LOAD_TABLE';
export const LOAD_DETALLE_TRAMITE = 'LOAD_DETALLE_TRAMITE';
export const SET_ARCHIVOS_ETAPAS = 'SET_ARCHIVOS_ETAPAS';
export const SET_TRAMITE_RESPONDER = 'SET_TRAMITE_RESPONDER';

//Equivalencias
export const EQUIVALENCIAS_ESTADOS = {
  'en proceso': 'En Proceso',
  'pendiente': 'Pendiente',
  'finalizado': 'Finalizado',
  'rechazado': 'Finalizado',
  'cerrado': 'Finalizado',
};

//Circulos
export const CAPWEB_GET_CIRCLE_DATA = 'CAPWEB_GET_CIRCLE_DATA';
export const REMOVE_TRAMITE_FROM_PENDIENTES = 'REMOVE_TRAMITE_FROM_PENDIENTES';
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB';
export const SELECT_TRAMITE_AUTORIZACION = 'SELECT_TRAMITE_AUTORIZACION';
export const SELECT_AFILIADO_AUTORIZACION = 'SELECT_AFILIADO_AUTORIZACION';
export const CAP_LIQUIDACIONES_SET_INVOICE = 'CAP_LIQUIDACIONES_SET_INVOICE';
export const AGREGAR_ARCHIVO_SUCCESS = 'AGREGAR_ARCHIVO_SUCCESS';
export const AGREGAR_ARCHIVO_ERROR = 'AGREGAR_ARCHIVO_ERROR';

//User
export const LOGIN_USER = 'LOGIN_USER';
export const RENEW_TOKEN = 'RENEW_TOKEN';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_USER_DETAIL = 'SET_USER_DETAIL';
export const LOGOUT_USER = 'LOGOUT_USER';
export const REGISTER_USER = 'REGISTER_USER';
export const REGISTER_USER_VALIDATE_PROVIDER = 'REGISTER_USER_VALIDATE_PROVIDER';
export const USER_PERMISSIONS = 'USER_PERMISSIONS';

//Branches
export const FETCH_BRANCHES = 'FETCH_BRANCHES';
export const FETCH_BRANCHES_SELECT_DATA = 'FETCH_BRANCHES_SELECT_DATA';

// Info Swiss
export const FETCH_INFO_SWISS_DATA = 'FETCH_INFO_SWISS_DATA';

// Revista Aequalis
export const FETCH_REVISTAS_AEQUALIS = 'FETCH_REVISTAS_AEQUALIS';

//Consultas pagos facturas
export const FETCH_PAGOS = 'FETCH_PAGOS';

//registrar usuarios
export const POST_REGISTER_USER = 'POST_REGISTER_USER';

//borrar usuario
export const DELETE_REGISTER_USER = 'DELETE_REGISTER_USER';

//modificar usuario
export const UPDATE_REGISTER_USER = 'UPDATE_REGISTER_USER';

//datos del usuario logeado
export const UPDATE_PERSONAL_DATA = 'UPDATE_PERSONAL_DATA';

//olvide contraseña
export const FORGOT_PASSWORD_VALIDATE_PROVIDER = 'FORGOT_PASSWORD_VALIDATE_PROVIDER';
export const FORGOT_PASSWORD_VALIDATE_TOKEN = 'FORGOT_PASSWORD_VALIDATE_TOKEN';
export const FORGOT_PASSWORD_SEND_PIN_MAIL = 'FORGOT_PASSWORD_SEND_PIN_MAIL';
export const FORGOT_PASSWORD_VALIDATE_PIN = 'FORGOT_PASSWORD_VALIDATE_PIN';
export const FORGOT_PASSWORD_UPDATE_PROVIDER_PASSWORD = 'FORGOT_PASSWORD_UPDATE_PROVIDER_PASSWORD';
export const PIN_VALIDATION_TIMER = 12000; // 2 minutes;
export const DEFAULT_PIN_SENDER_BUTTON_TEXT = 'ENVIAR PIN';
export const DEFAULT_RETRY_PIN_SENDER_BUTTON_TEXT = 'ENVIAR NUEVO PIN';

//Tramites de autorizaciones
export const CAPWEB_AUTORIZACIONES_TIEMPO_MAX = 180;
export const MSG_PLANES_PARCIALES = 'MSG_PLANES_PARCIALES';
export const GUARDAR_DATOS_ALTA_SUCCESS = 'GUARDAR_DATOS_ALTA_SUCCESS';
export const GUARDAR_DATOS_ALTA_ERROR = 'GUARDAR_DATOS_ALTA_ERROR';

export const ES_AUTORIZABLE_SUCCESS = 'ES_AUTORIZABLE_SUCCESS';
export const ES_AUTORIZABLE_ERROR = 'ES_AUTORIZABLE_ERROR';
export const RESET_ES_AUTORIZABLE_SUCCESS = 'RESET_ES_AUTORIZABLE_SUCCESS';
export const RESET_ES_AUTORIZABLE_ERROR = 'RESET_ES_AUTORIZABLE_ERROR';

//Users managment
export const FETCH_MANAGE_USER = 'FETCH_MANAGE_USER';
export const FETCH_USER_BY_ID = 'FETCH_USER_BY_ID';
export const FETCH_USER_PERMISSIONS_BY_ID = 'FETCH_USER_PERMISSIONS_BY_ID';
export const FETCH_ALL_USER_PERMISSIONS_BY_ID = 'FETCH_ALL_USER_PERMISSIONS_BY_ID';
export const REGISTER_SURVEY_RESPONSE = 'DOC24_FEED_PRACTITIONER_DATA';
export const GET_SECTOR_ROLE = 'GET_SECTOR_ROLE';

//Formulario de contacto
export const SEND_CONTACT_FORM = 'SEND_CONTACT_FORM';

//Terms and conditions
export const GET_TERMS_AND_CODITION = 'GET_TERMS_AND_CODITION';
export const UPDATE_TERMS_AND_CODITION = 'UPDATE_TERMS_AND_CODITION';
export const STATUS_TERMS_AND_CODITION = 'STATUS_TERMS_AND_CODITION';

// DOC 24
export const ENABLED_DOC_24 = 'ENABLED_DOC_24';
export const DOC24_FEED_PRACTITIONER_DATA = 'DOC24_FEED_PRACTITIONER_DATA';

export const CUIT_SWISS_MEDICAL = '30654855168';

// Censos
export const CENSOS = {
  pasos: {
    labels: {
      paso1: 'Paso 1',
      paso2: 'Paso 2',
    },
  },

  paso2: {
    buttonpicker: {
      Ingreso: {
        codigo: '43422003',
        label: 'Ingreso',
      },
      Egreso: {
        codigo: '43422004',
        label: 'Egreso',
      },
    },

    selectPicker: {
      Ingreso: [
        {
          codigo: '',
          label: 'Seleccione',
        },
        {
          codigo: '43422023',
          label: 'Ingreso Recien Nacido 1',
        },
        {
          codigo: '43422033',
          label: 'Ingreso Recien Nacido 2',
        },
        {
          codigo: '43422043',
          label: 'Ingreso Recien Nacido 3',
        },
      ],

      Egreso: [
        {
          codigo: '',
          label: 'Seleccione',
        },
        {
          codigo: '43422024',
          label: 'Egreso Recien Nacido 1',
        },
        {
          codigo: '43422034',
          label: 'Egreso Recien Nacido 2',
        },
        {
          codigo: '43422044',
          label: 'Egreso Recien Nacido 3',
        },
      ],
    },
  },
};

export const DATE_FOCUS = {
  START_DATE: 'startDate',
  END_DATE: 'endDate',
};

export const SURVEY_BASE_URL = 'https://swissbrand.qualtrics.com';

export const reportTypes = {
  BENEFIT: 'IP',
  DIAGNOSIS: 'ID',
  INMEDIATE: 'II',
};
